export interface UrgentAction {
	id: number;
	actionTitle: string;
	actionLink: string;
	daysFromNotification: number;
	finished: boolean;
}
export const mockedActions: UrgentAction[] = [
	{
		id: 1,
		actionTitle: "Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod Temporasdasdasdasdasdsads dfsdfsdfsdf",
		actionLink: "https://www.google21.com",
		daysFromNotification: 1,
		finished: false,
	},
	{
		id: 2,
		actionTitle: "Lorem Ipsum Dolor Sit Amet",
		actionLink: "https://www.google32.com",
		daysFromNotification: 2,
		finished: false,
	},
	{
		id: 3,
		actionTitle: "Lorem Ipsum Dolor",
		actionLink: "https://www.googl434e.com",
		daysFromNotification: 3,
		finished: false,
	},
	{
		id: 4,
		actionTitle: "Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
		actionLink: "https://www.googl4543e.com",
		daysFromNotification: 4,
		finished: true,
	},
	{
		id: 5,
		actionTitle: "Lorem Ipsum Dolor Sit Amet",
		actionLink: "https://www.goo4354gle.com",
		daysFromNotification: 5,
		finished: true,
	},
	{
		id: 6,
		actionTitle: "Lorem Ipsum Dolor",
		actionLink: "https://www.goog435le.com",
		daysFromNotification: 6,
		finished: true,
	},
	{
		id: 7,
		actionTitle: "Lorem Ipsum Dolor Sit Amet Consectetur Adipiscing Elit Sed Do Eiusmod",
		actionLink: "https://www.googl435e.com",
		daysFromNotification: 7,
		finished: true,
	},
];
